<p-fieldset>
    <p-header class="article-title">
        <span class="article-title">{{ 'TITLE-GENERAL-CONFIG' | translate }}</span>
    </p-header>

    <app-sling-config-form *ngIf="slingConfig"
        [inlineData]="{ slingConfig: slingConfig, multiQueue: multiQueue, marinaCompanies: marinaCompanies }"
        (saved)="loadForm()">
    </app-sling-config-form>
</p-fieldset>
